import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';

const UPDATE_LOCALE_MUTATION = gql`
  mutation updateLocale2($input: UpdateUserLocaleInput!) {
    updateLocale2(input: $input) {
      resourceLocale {
        timeZone {
          displayText
          ianaName
          offsetDisplayText
          uri
          id
        }
      }
    }
  }
`;

export const useUpdateUserTimeZone = ({ userUri, onClose }) => {
  const [updateLocale, { loading }] = useMutation(UPDATE_LOCALE_MUTATION);

  const updateUserTimeZone = useCallback(
    async timeZoneUri => {
      await updateLocale({
        variables: {
          input: {
            userUri,
            timeZoneFormatUri: timeZoneUri
          }
        },
        refetchQueries: ['getResourceDetailsBySlug'],
        awaitRefetchQueries: false
      });
      onClose();
    },
    [updateLocale, userUri, onClose]
  );

  return { updateUserTimeZone, loading };
};
